import { getFieldValue } from "@digitallab/grid-common-components";

const BooleanRender = (params) => {
  if (params?.column?.colId === "is_bookable") {
    return <div>{getFieldValue(params?.data, "is_bookable")}</div>;
  }
  if (params?.column?.colId === "is_visualized") {
    return <div>{getFieldValue(params?.data, "is_visualized")}</div>;
  }

  return <div>{"false"}</div>;
};

export default BooleanRender;
